import {BenefitFlow} from 'src/CreateTransactionForBenefitModal/BenefitFlow';
import type {FromBenefitProps} from 'src/CreateTransactionForBenefitModal/BenefitFlow';

// The review-side entry (InboxFlow) folded into CreateTransactionModal's
// Tags & Fields strip as a benefit attachment; what remains is the
// benefit-side entry from the card benefits view, which starts from a
// preselected benefit and picks the raw transaction.
export type CreateTransactionForBenefitModalUserProps = FromBenefitProps;
export const CreateTransactionForBenefitModal = BenefitFlow;
